import React from 'react';
import { FormattedMessage } from 'react-intl';
import MenuList from './MenuList';
import queryContext from './query-context';

const queryCatalogText = {
  backText: (
    <FormattedMessage
      id="query.backText"
      defaultMessage="Back to Database Tools"
      description="Link back to database tools "
    />),
    queryHeader: (
      <FormattedMessage
        id="query.header"
        data-test="header-text"
        defaultMessage="Query Catalog"
        description="The title for the page to view the query catalog">
        {(txt) => (
          <h1
            className="no-margin text-deep-blue text-center"
            data-test="header-text-device">
            {txt}
          </h1>
        )}
      </FormattedMessage>
    ),
}

function QueryCatalog() {
  const { catalog, onToggleChildren } = React.useContext(queryContext);
  //console.log('QueryCatalog: catalog: ', catalog)

  return (
    <div className="container">
      <div className="layout-container content-container content-container--column content-container--shadow">

        <div className="content-display__container content-display__container--column align-center">
          {queryCatalogText.queryHeader}
          <hr />

          <div
            className="content-display__container"
            data-test="content-container">
            <div
              className="content-display__column"
              data-test="query-catalog-container">
              <div
                className="content-display__column"
                data-test="query-catalog-container">
                <div className="content-display__item-pill-container">
                  <div className="item-container__main-container">
                  <div className="tree-view-container">
                    <MenuList itemList={catalog} onToggleChildren={onToggleChildren} />
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// const mapStateToProps = (state) => {
//   return {};
// }

export default QueryCatalog;
